import "../pages/Omnie.css";
import { Link } from "react-router-dom";
import myPhoto from "../assets/pictures/sandra-krzeslo.webp"; // ← tu dodaj swoje zdjęcie do folderu /src/assets/

const Omnie = () => {
  return (
    <div className="about-wrapper">
      <div className="about-image">
        <img src={myPhoto} alt="Sandra - projektantka wnętrz" />
      </div>

      <div className="about-content">
        <h2>KILKA SŁÓW O MNIE</h2>
        <p>
          Nazywam się <strong className="highlight">Sandra</strong>. Jestem dyplomowaną <strong className="highlight">projektantką wnętrz</strong> oraz <strong className="highlight">inżynierem budownictwa</strong> – łączę techniczną precyzję z artystycznym wyczuciem lecz to właśnie projektowanie wnętrz od zawsze było moją największą pasją i kierunkiem, w którym chciałam się rozwijać.
        </p>
        <br />
        <p>
          W swojej pracy stawiam na <strong className="highlight">funkcjonalność</strong>, <strong className="highlight">estetykę</strong> i dopasowanie do <strong className="highlight">indywidualnych potrzeb klienta</strong>. Specjalizuję się w <strong className="highlight">aranżacji mieszkań</strong> – to one w największym stopniu kształtują nasze codzienne życie i samopoczucie.
        </p>
        <br />
        <p>
          Działam głównie w okolicach <strong className="highlight">Więcborka</strong> i <strong className="highlight">Bydgoszczy</strong>, ale chętnie podejmuję się również <strong className="highlight">projektów zdalnych na terenie całej Polski</strong>. Oferuję kompleksową usługę – od <strong className="highlight">koncepcji</strong>, przez <strong className="highlight">szczegółowe rysunki i wizualizacje</strong>, aż po <strong className="highlight">nadzór realizacji z udziałem zaufanych wykonawców</strong>. Dbam o każdy detal, po to, aby Twój dom był nie tylko piękny, ale i wygodny.
        </p>

        <div className="buttons">
          <Link to="/realizacje">
            <button className="btn">ZOBACZ MOJE PORTFOLIO</button>
          </Link>
          <Link to="/kontakt">
            <button className="btn">NAPISZ DO MNIE</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Omnie;
